<script setup lang="ts">
    import { onMounted } from 'vue';
    import { useEventStore } from '@/stores/event';

    const {
        headerText = undefined,
        valueOne,
        numbersClass = 'orangeText',
        valueTwo,
        withPercent = false,
        filledColor = undefined,
        filledDarkerColor = undefined,
        backgroundColor = undefined,
    } = defineProps<{
        headerText?: string;
        valueOne: number;
        numbersClass?: string;
        valueTwo: number;
        withPercent?: boolean;
        filledColor?: string;
        filledDarkerColor?: string;
        backgroundColor?: string;
    }>();

    onMounted(() => {
        console.log('Component %s mounted.', 'app-eventStatsRow');
    });

    const eventStore = useEventStore();

    function getValue(value: number): number | string {
        if (value && withPercent) {
            return value + '%';
        }
        return value;
    }
</script>

<template>
    <v-container v-if="eventStore.stats" class="px-0 py-3">
        <v-row class="font14" style="height: 18px">
            <v-col
                class="text-start py-0 pr-0"
                :class="[eventStore.stats.time === 'FT' ? 'ft-stats' : numbersClass, Number(valueOne) > Number(valueTwo) ? 'bold' : '']"
                style="min-width: 40px; max-width: 40px; height: 18px"
            >
                {{ getValue(valueOne) }}
            </v-col>
            <v-col class="text-center py-0" style="height: 18px">
                {{ headerText }}
            </v-col>
            <v-col
                class="text-end py-0 pl-0 orangeText"
                :class="[eventStore.stats.time === 'FT' ? 'ft-stats' : numbersClass, Number(valueTwo) > Number(valueOne) ? 'bold' : '']"
                style="min-width: 40px; max-width: 40px; height: 18px"
            >
                {{ getValue(valueTwo) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-start pt-0 pb-1 pr-1">
                <v-progress-linear
                    :model-value="Math.ceil((Number(valueOne) / (Number(valueOne) + Number(valueTwo))) * 100)"
                    reverse
                    :color="Number(valueOne) >= Number(valueTwo) ? filledDarkerColor : filledColor"
                    :bg-color="backgroundColor"
                    bg-opacity="100"
                    height="10"
                    rounded
                ></v-progress-linear>
            </v-col>
            <v-col class="text-start pt-0 pb-1 pl-1">
                <v-progress-linear
                    :model-value="Math.ceil((Number(valueTwo) / (Number(valueOne) + Number(valueTwo))) * 100)"
                    :color="Number(valueTwo) >= Number(valueOne) ? filledDarkerColor : filledColor"
                    :bg-color="backgroundColor"
                    bg-opacity="100"
                    height="10"
                    rounded
                ></v-progress-linear>
            </v-col>
        </v-row>
    </v-container>
</template>

<style scoped>
    .ft-stats {
        color: #545454;
    }

    .v-theme--dark .ft-stats {
        color: #b5bac1;
    }

    .orangeDarkText {
        color: #b3772a;
    }
</style>
